module.exports = __webpack_public_path__ + "static/media/feima.3a99250f.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/all/feima.png
// module id = 175
// module chunks = 1